// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fykVd","largestCol":"styles_largestCol__2oFwS","smallestCol":"styles_smallestCol__2CAKw"};